import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import RefreshIcon from "@material-ui/icons/Refresh";
import Base from "../../base/views/base";
import { AdminMenuListItems } from "./AdminMenuListItems";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter"
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import Container from "@material-ui/core/Container";
import MaterialTable from "material-table";


const useStyles = makeStyles((theme) => ({

  root: {
    width:"100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  pricingheader: {
    marginTop: theme.spacing(2),
  },
  card: {
    height: 400,
    width: "100%",
    maxWidth: 195,
    position: "relative",
    borderRadius: 16,
    display: "flex",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    flexDirection: "column",
    paddingTop: 4,
    paddingBottom: 4,
    "&:last-child": {
      paddingRight: 5,
    },
    flexShrink: 0,
    marginRight: theme.spacing(5),
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  cardHeader: {
    fontSize: "small",
  },
  cardpaidlist: {
    paddingTop: 5,
    justifyContent: "center",
    paddingLeft: 10,
  },
  cardpaid: {
    paddingTop: 2,
    paddingLeft: 2,
    fontSize: "small",
    justifyContent: "center",
  },
  planswitcher: {
    paddingBottom: 12,
    paddingTop: 4,
  },
  showallplan: {
    paddingBottom: 12,
    paddingTop: 10,
    justifyContent: "center",
    display: "flex",
  },
  cardpaidlisticon: {
    position: "relative",
    top: 8,
  },
  gridlisticon: {
    position: "relative",
    left: 25,
  },
  appBar: {
    backgroundColor: "rgba(255,255,255,0.5)",
  },
  title: {
    flexGrow: 1,
    color: "rgba(0, 0, 0, 0.7);",
  },
  plantable: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantable2: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantableheader: {
    alignItems: "center",
    display: "inline-flex",
    flexWrap: "Wrap",
    justifyContent: "left",
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor:"rgba(255,255,255,0.5)",
    backdropFilter:"blur(8px)"    
  },
  commingsoon: {
    border: "2px solid #0b8043",
    borderRadius: 4,
    fontSize: "small",
    lineHeight: 1.2,
    marginTop: 5,
    marginLeft: 10,
    padding: 5,
    textAlign: "center",
  },
}));

const t1available = 0
const t1assigned = 8
const t1total = 8
const t2available = 5
const t2assigned = 3
const t2total = 8

const headCells = [
  { title: "Name", field: "name", defaultSort: "asc"},
  { title: "Available Subscriptions", field: "availablesubs" },
  { title: "Account type", field: "type" },
];

const gridData = [
  {
    name: "Inventory Management",
    availablesubs: [t1available, " available, ", t1assigned, " assigned of ",t1total," total"],
    type: "Allowed"
  },
  {
    name: "Asset Management",
    availablesubs: [t2available, " available, ", t2assigned, " assigned of ",t2total," total"],
    type: "Allowed"
  },
  
];

function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="static" {...props} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }
  
  CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate and static variants.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
  };

export default function Billing() {

  const classes = useStyles();

  return (
    
    <div style={{display:"flex"}}>
    <Base menuItems={AdminMenuListItems} hidePharmacyButton={true}>
      <h1 style={{marginTop:"5%"}}>Billing</h1>
            <Container maxWidth="lg" className={classes.container}>
              <Button
                className={classes.button}
                startIcon={<GetAppOutlinedIcon />}
              >
                Export
              </Button>
              <Button className={classes.button} startIcon={<RefreshIcon />}>
                Refresh
              </Button>
              </Container>
              <div className={classes.root}>
              <MaterialTable
                title="Active Users List"
                columns={headCells}
                data={gridData}
                actions={[
                  {
                    icon: "delete",
                    tooltip: "Deactivate Subscription",
                    onClick: (event, rowData) =>
                      window.confirm("Do you want to delete " + rowData.ndc + " ?"),
                  },
                  {
                    icon: "list",
                    tooltip: "Manage Subscriptions",
                    onClick: (event, rowData) =>
                      window.confirm("Do you want to delete " + rowData.ndc + " ?"),
                  },
                ]}
                options={{
                  maxBodyHeight: 400,
                  paging: true,
                  pageSize: 25,
                  pageSizeOptions: [25, 50, 100],
                  headerStyle: {
                    backgroundColor: 'rgba(255,255,255,0.5)',
                    color: 'black'
                  }
                }}
              />
            </div>
      <LandingPageFooter />
    </Base>
    </div>
    

  );
}
